// 结算导出相关类型定义
import { PageResponseType, PageRequestTypeInput, TimeRangeInput } from './CommonTypes';

export interface ExportTaskStatusType {
  taskId: string;
  status: string;
  progress: number;
  message: string;
  downloadUrl?: string;
  createdAt: string;
  completedAt?: string;
}

export interface ExportedFileType {
  fileId: string;
  fileName: string;
  fileSize: number;
  downloadUrl: string;
  exportType: string;
  status: string;
  createdAt: string;
  expiresAt: string;
}

export interface ExportFileFiltersInput {
  exportType?: string;
  status?: string;
  dateRange?: TimeRangeInput;
}


// 导出请求类型
export interface ExportBillInput {
  billIds: string[];
  exportType: string;
  templateId?: string;
}

export interface ExportBillResult {
  taskId: string;
  status: string;
  message: string;
}

// 导出模板类型
export enum BillExportTemplateType {
  TEMU_TEMPLATE = 'TEMU_TEMPLATE',
  TEMU_HALF_MANAGED_TEMPLATE = 'TEMU_HALF_MANAGED_TEMPLATE',
  GENERAL_TEMPLATE = 'GENERAL_TEMPLATE',
  CUSTOMER_STANDARD_TEMPLATE = 'CUSTOMER_STANDARD_TEMPLATE',
  SLA_TEMPLATE = 'SLA_TEMPLATE',
  DSP_DELIVERY_TEMPLATE = 'DSP_DELIVERY_TEMPLATE',
  TIKTOK_TEMPLATE = "TIKTOK_TEMPLATE",
  JD_TEMPLATE = 'JD_TEMPLATE',
  TT_SORTING_TEMPLATE = 'TT_SORTING_TEMPLATE',
}
